type FormattedDateProps = {
  date?: Date | null;
};

export const FormattedDate: React.FC<FormattedDateProps> = ({ date }) => {
  if (!date) {
    return null;
  }

  return (
    <>
      {date.toLocaleDateString("en-US")} {date.toLocaleTimeString("en-US")}
    </>
  );
};
